import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { convertObjectToQueryParams } from 'src/utils/util';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { EQUITYORDERTYPE } from 'src/pages/equity/components/common/constants';
import {
    GET_PRODUCT_BUNDLE_FAILURE,
    GET_PRODUCT_BUNDLE_SUCCESS,
} from '../actions/actionTypes';

const getSearchProductPromises = (cfnArray) => {
    const searchProductsPromiseArray = [];
    let url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productList?`;
    const cfnArrayCloned = [...cfnArray];
    while (cfnArrayCloned.length) {
        searchProductsPromiseArray.push(
            axios
                .get(
                    `${url}${convertObjectToQueryParams({
                        searchParam: 'productNumber',
                        orderType: EQUITYORDERTYPE,
                        searchTerm: cfnArrayCloned.splice(0, 10).join(),
                    })}`
                )
                .then((response) => response.data)
        );
    }

    return searchProductsPromiseArray;
};

const ErrorCheck = (productsList) => {
    if (productsList?.length > 0) {
        return productsList;
    } else {
        return [];
    }
};

export default function* searchProductsBundle(action) {
    try {
        const results = yield Promise.all(
            getSearchProductPromises(action.payload || [])
        );
        let mergedResult = [];
        results.forEach(({ productsList }) => {
            mergedResult = [...mergedResult, ...ErrorCheck(productsList)];
        });
        const finalResult = [];
        action.payload &&
            action.payload.forEach((productNumber) => {
                const fetchedProduct = mergedResult.find(
                    (result) =>
                        result.cfn.toUpperCase() === productNumber.toUpperCase()
                );
                if (fetchedProduct) {
                    finalResult.push({ ...fetchedProduct, quantity: 1 });
                } else {
                    finalResult.push({ cfn: productNumber, quantity: 0,isPlusIconDisable:true });
                }
            });
        yield put({
            type: GET_PRODUCT_BUNDLE_SUCCESS,
            products: finalResult.sort((a, b) => a.quantity - b.quantity),
            statusCode: results[0].statusCode,
            statusMessage: results[0].statusMessage,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/products/productList`,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRODUCT_BUNDLE_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
